import styled from 'astroturf/react';

const TimelineProgressBarWrapper = styled('div')`
  display: flex;
  align-items: center;
  margin-left: 20px;
  margin-top: 30px;

  [class*="position-absolute"] {
    position: absolute;
  }
    
  [class*="position-relative"] {
    position: relative;
  }
  
  [class*='top-[-5px]'] {
    top: -5px;
  }

  [class*='top-[-35px]'] {
    top: -35px;
  }

  [class*='top-[15px]'] {
    top: 15px;
  }
  
  [class*='top-[30px]'] {
    top: 30px;
  }

  [class*='top-[45px]'] {
    top: 45px;
  }
  
  [class*='right-[25px]'] {
    right: 25px;
  }
`;

const Milestone = styled('div')`
  width: 14px;
  height: 14px;
  border: 4px solid var(--dark-blue);
  background: var(--white);
  opacity: 1;
  border-radius: 100%;

  &.isAchieved {
    background: var(--dark-blue);
  }
  
  &.isNotAchieved {
    border: 4px solid var(--ph-light-gray);
    background: var(--white);
  }

  &.isDelayed {
    border: 4px solid var(--ph-red-500);
    background: var(--white);
  }
`;

const Label = styled('p')`
  margin: 0;
  font-size: var(--ph-required-indicate);
  color: var(--ph-gray-450);
  word-break: unset;
  width: max-content;

  &.isBold {
    font-family: var(--ph-font-family-source-sans-pro-semibold);
  }

  &.isBlue {
    color: var(--dark-blue);
  }

  &.isRed {
    color: var(--ph-red-500);
  }
`;

const MiddleLabelWrapper = styled('div')`
  left: 85px;
`;

const ProgressBar = styled('div')`
  height: 5px;
  background: var(--ph-light-gray);

  &.inProgress {
    background: linear-gradient(to right, var(--dark-blue) 0%, var(--dark-blue) 50%, var(--ph-light-gray) 50%, var(--ph-light-gray) 100%);
  }

  &.isCompleted {
    background: var(--dark-blue);
  }

  &.hasDelay {
    background: linear-gradient(to right, var(--dark-blue) 0%, var(--dark-blue) 50%, var(--ph-red-500) 50%, var(--ph-red-500) 100%);
  }
`;

const ProgressBarWrapper = styled('div')`
  width: 190px;
`;

export default {
  Label,
  MiddleLabelWrapper,
  Milestone,
  ProgressBar,
  ProgressBarWrapper,
  TimelineProgressBarWrapper,
}
